import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSelect,{attrs:{"items":_vm.localTypes,"item-text":"name","item-value":"id","hide-no-data":"","label":_vm.$t('labels.blockerType'),"required":"","error-messages":_vm.errors,"menu-props":{ maxWidth: '316px', closeOnContentClick: true }},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }